import React from "react"
import { Flex, Card, Typography } from "antd"
import { CheckCircleFilled, ClockCircleFilled } from "@ant-design/icons"
import { useTheme } from "context/AntdThemeContext"
import { themes } from "constants/theme"
import bgMan from "assets/imagesV2/logo_man.svg"
import bgWoman from "assets/imagesV2/logo_woman.svg"
import styles from "./index.module.css"
import { useLocation } from "react-router-dom"

const { Title, Text } = Typography

export default function WaiverThankYou() {
  const { theme } = useTheme()
  const logoSrc = theme === themes.sportswoman ? bgWoman : bgMan
  const location = useLocation()
  const isDraft = location.state?.isDraft

  return (
    <Flex vertical className={styles.container} align="center">
      <div className={styles.logoBar}>
        <img src={logoSrc} alt="Digital Sportsman" className={styles.logo} />
      </div>

      <Flex className={styles.cardWrapper} align="center" justify="center" flex={1}>
        <Card className={styles.card}>
          <Flex vertical align="center" gap={24}>
            {isDraft
              ? <ClockCircleFilled className={styles.checkIcon} style={{ color: "var(--color-primary)" }} />
              : <CheckCircleFilled className={styles.checkIcon} />
            }

            <Flex vertical align="center" gap={8}>
              <Title level={2} className={styles.title}>
                Thank You!
              </Title>
              {isDraft ? (
                <>
                  <Text className={styles.subtitle}>
                    Your waiver has been saved as a draft.
                  </Text>
                  <Text className={styles.description}>
                    You can come back and finish signing whenever you're ready. A resume link will be sent to your email or phone number.
                  </Text>
                </>
              ) : (
                <>
                  <Text className={styles.subtitle}>
                    Your documents have been successfully signed.
                  </Text>
                  <Text className={styles.description}>
                    A copy of the signed waiver will be sent to your email address.
                  </Text>
                </>
              )}
            </Flex>
          </Flex>

          <Flex justify="center" align="center" gap={8} className={styles.poweredByRow}>
            <Text className={styles.poweredByText}>Powered by</Text>
            <img src={logoSrc} alt="Digital Sportsman" className={styles.poweredLogo} />
          </Flex>
        </Card>
      </Flex>
    </Flex>
  )
}
